"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _CompletedPart_1 = require("./_CompletedPart");
exports._CompletedPartList = {
    type: "list",
    flattened: true,
    member: {
        shape: _CompletedPart_1._CompletedPart
    }
};
//# sourceMappingURL=_CompletedPartList.js.map